import * as React from 'react';
import {Dispatch} from 'redux';
import {connect} from 'react-redux';

import {globalDispatchToPropsObject} from '../../store';
import * as logoIMG from '../images/logogray.png';
import {BoundedContainer} from '../util';

const LICENSE_URL = 'https://www.socotra.com/license';

interface DispatchProps {
	logIn(request: AuthenticateRequest): Promise<Partial<UserState>>;
}

interface LoginState {
	username?: string;
	password?: string;
}

function mapDispatchToProps(dispatch: Dispatch<StudioState>): DispatchProps {
	const {logIn} = globalDispatchToPropsObject;
	return {
		logIn: request => dispatch(logIn(request)),
	};
}

class Login extends React.Component<DispatchProps, LoginState> {

	public state: LoginState = {
		username: '',
		password: '',
	};

	constructor(props: DispatchProps, context: any) {
		super(props, context);
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.handleChangeUsername = this.handleChangeUsername.bind(this);
		this.handleChangePassword = this.handleChangePassword.bind(this);
	}

	public render() {
		return <BoundedContainer>
			<div className='login'>
				<img className='login-logo' src={logoIMG} />
				{this.renderForm()}
			</div>
		</BoundedContainer>;
	}

	private renderForm() {
		return <form onSubmit={this.handleFormSubmit}>
			<div className='row'>
				<label>
					Username
					<input
						type='text'
						value={this.state.username}
						onChange={this.handleChangeUsername}
						autoComplete='on'
						autoFocus
					/>
				</label>
			</div>
			<div className='row'>
				<label>
					Password
					<input
						type='password'
						value={this.state.password}
						onChange={this.handleChangePassword}
						autoComplete='off'
					/>
				</label>
			</div>
			<div className='row'>
				<p>
					<a href={LICENSE_URL} target='_blank'>View License Agreement</a>
				</p>
			</div>
			<div className='row'>
				<button type='submit' disabled={!this.state.username || !this.state.password}>
					Accept License &amp; Login
				</button>
			</div>
		</form>;
	}

	private handleChangeUsername(event: FormInputEvent) {
		this.setState({username: event.currentTarget.value});
	}

	private handleChangePassword(event: FormInputEvent) {
		this.setState({password: event.currentTarget.value});
	}

	private handleFormSubmit(event: React.FormEvent<HTMLFormElement>) {
		const {username, password} = this.state;
		event.preventDefault();
		this.props.logIn({username, password});
	}

}

export default connect<{}, DispatchProps, {}>
	(null, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/config-studio-index/Login.tsx